export const KGF_THUMBNAIL_BASE = "https://storage.googleapis.com/kgf-thumbnails";
export const KITTY_THUMBNAIL_BASE =
  "https://storage.googleapis.com/kitties-thumbnails";

export const BLOODY_THUMBNAIL_BASE =
  "https://storage.googleapis.com/bloody-thumbnails";
export const BLOODY_FULL_BASE = "https://storage.googleapis.com/bloody-full";
export const KGF_HIRES_IPFS_BASE =
  "https://ipfs.io/ipfs/QmTifGUmic9roD1BuH62QmzZTVWapUSD5m5dwcgjuaHGHQ";
export const KGF_CONTRACT = "0x6be69b2a9b153737887cfcdca7781ed1511c7e36";

export const kgfThumbnail = (id: number | string) =>
  `${KGF_THUMBNAIL_BASE}/${id}.jpg`;

export const kittyThumbnail = (id: number | string) =>
  `${KITTY_THUMBNAIL_BASE}/${id}.webp`;

export const kgfHiRes = (id: number | string) =>
  `${KGF_HIRES_IPFS_BASE}/${id}.png`;

export const bloodyThumbnail = (id: number | string) =>
  `${BLOODY_THUMBNAIL_BASE}/${id}.jpg`;

export const bloodyFull = (id: number | string) =>
  `${BLOODY_FULL_BASE}/${id}.png`;

export const openSeaAssetUrl = (id: number | string) =>
  `https://opensea.io/assets/ethereum/${KGF_CONTRACT}/${id}`;
